import React, { Component } from 'react';
import { Link, withRouter,} from 'react-router-dom';
import * as routes from '../Constants/routes';
import { Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { auth, db } from '../firebase';

const SignUpPage = ({ history }) =>
    <SignUpForm history={history}/>

const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    inGameName: "",
    error: null,
  };

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
  });

class SignUpForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      username,
      inGameName,
      email,
      passwordOne,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        // Create a user in your own accessible Firebase Database too
        db.doCreateUser(authUser.uid, username, email, inGameName)
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push(routes.HOME);
          })
          .catch(error => {
            this.setState(byPropKey('error', error));
          });
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    var signUpStyle = {
      backgroundColor: "white",
      marginTop: 50
    };
    var h2Style = {
      paddingLeft: 10,
      paddingTop: 5,
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    }

    const {
      username,
      email,
      inGameName,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      inGameName === '' ||
      username === '';

    return (
      <div className="container" style={signUpStyle} >
      <Form onSubmit={this.onSubmit} >
       <FormGroup row>
       <h2 style={h2Style}>Create an Account</h2>
       </FormGroup>
        <FormGroup row>
          <Label for="userName" sm={2}>User Name</Label>
          <Col sm={10}>
            <Input id="userName"
              value={username}
              onChange={event => this.setState(byPropKey('username', event.target.value))}
              type="text"
              placeholder="User Name for Site"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="inGameName" sm={2}>Nova Blitz User Name</Label>
          <Col sm={10}>
            <Input id="inGameName"
              value={inGameName}
              onChange={event => this.setState(byPropKey('inGameName', event.target.value))}
              type="text"
              placeholder="Nova Blitz in Game Name"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="email" sm={2}>Email</Label>
          <Col sm={10}>
            <Input id="email"
              value={email}
              onChange={event => this.setState(byPropKey('email', event.target.value))}
              type="email"
              placeholder="Email Address"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="passwordOne" sm={2}>Password</Label>
          <Col sm={10}>
          <Input id="passwordOne"
            value={passwordOne}
            onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
            type="password"
            placeholder="Password"
          />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="passwordTwo" sm={2}>Confirm Password</Label>
          <Col sm={10}>
          <Input id="passwordTwo"
            value={passwordTwo}
            onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
            type="password"
            placeholder="Confirm Password"
          />
          </Col>
        </FormGroup>
         <Button disabled={isInvalid} type="submit" className="btn">
          Sign Up
        </Button>

        { error && <p>{error.message}</p> }
      </Form>
      </div>
    );
  }
}

const SignUpLink = () =>
  <p align="center">
    You do not have an account?
    {' '}
    <Link to={routes.SIGN_UP}>Sign Up</Link>
  </p>

export default withRouter(SignUpPage);

export {
  SignUpForm,
  SignUpLink,
};



// WEBPACK FOOTER //
// ./src/Authentication/SignUp.js